import { jsx as _jsx } from "react/jsx-runtime";
import { CardContent } from "@mui/material";
import { forwardRef } from "react";
export const UiCardContent = forwardRef((props, ref) => _jsx(CardContent, Object.assign({ ref: ref }, props)));
//# sourceMappingURL=ui_card_content.js.map